const Permissions = {
    CONFIGURATION_CATALOG_UPDATE: 'CONFIGURATION_CATALOG_UPDATE',
    CONFIGURATION_CATALOG_TAGS: 'CONFIGURATION_CATALOG_TAGS',
    CONFIGURATION_CATALOG_PLACES: 'CONFIGURATION_CATALOG_PLACES',
    CONFIGURATION_CATALOG_SHUTDOWN: 'CONFIGURATION_CATALOG_SHUTDOWN',

    CONFIGURATION_WORKING_TIME_UPDATE: 'CONFIGURATION_WORKING_UPDATE',
    CONFIGURATION_WORKING_TIME_ACTIVE_DAY: 'CONFIGURATION_WORKING_TIME_ACTIVE_DAY',

    CONFIGURATION_LOCALIZATION: 'CONFIGURATION_LOCALIZATION',

    CONFIGURATION_DELIVERY_REGIONS_UPDATE: 'CONFIGURATION_DELIVERY_REGIONS_UPDATE',
    CONFIGURATION_DELIVERY_REGIONS_TIME_UPDATE: 'CONFIGURATION_DELIVERY_REGIONS_TIME_UPDATE',

    CONFIGURATION_OFFLINE_PAYMENT: 'CONFIGURATION_OFFLINE_PAYMENT',

    CONFIGURATONS_TABLES_VIEW: 'CONFIGURATONS_TABLES_VIEW',

    CONFIGURATION_OTHERS: 'CONFIGURATION_OTHERS',

    INTEGRATION_PAYMENT_PAGARME: 'INTEGRATION_PAYMENT_PAGARME',
    INTEGRATION_PAYMENT_WOOVI: 'INTEGRATION_PAYMENT_WOOVI',
    INTEGRATION_PAYMENT_SAFRAPAY: 'INTEGRATION_PAYMENT_SAFRAPAY',
    INTEGRATION_PAYMENT_ADYEN: 'INTEGRATION_PAYMENT_ADYEN',
    INTEGRATION_PAYMENT_CLEARSALE: 'INTEGRATION_PAYMENT_CLEARSALE',

    INTEGRATION_GOOGLE_MAPS: 'INTEGRATION_GOOGLE_MAPS',
    INTEGRATION_GOOGLE_ANALYTICS: 'INTEGRATION_GOOGLE_ANALYTICS',
    INTEGRATION_GOOGLE_TAG_MANAGER: 'INTEGRATION_GOOGLE_TAG_MANAGER',

    INTEGRATION_LOGISTICS_IFOOD: 'INTEGRATION_LOGISTICS_IFOOD',
    INTEGRATION_LOGISTICS_MOTTU: 'INTEGRATION_LOGISTICS_MOTTU',
    INTEGRATION_LOGISTICS_FOODY_DELIVERY: 'INTEGRATION_LOGISTICS_FOODY_DELIVERY',

    INTEGRATION_DATA_OLGA: 'INTEGRATION_DATA_OLGA',

    CONFIGURATION_SCHEDULE_UPDATE: 'CONFIGURATION_SCHEDULE_UPDATE',

    ORDERS_ACCEPT: 'ORDERS_ACCEPT',
    ORDERS_REJECT: 'ORDERS_REJECT',
    ORDERS_CANCEL: 'ORDERS_CANCEL',
    ORDERS_DISPATCH: 'ORDERS_DISPATCH',
    ORDERS_FINISH: 'ORDERS_FINISH',
}

export {
    Permissions
}